import React from 'react';

import CreditEntryTableRow from './CreditEntryTableRow';

import './CreditEntryTable.scss';
import featureFlags from '../../../featureFlags';

class CreditEntryTable extends React.Component {
  _onCreditEntryChange(ident) {
    return value => {
      this.props.onCreditEntryChange(ident, value);
    }
  }

  render() {
    const {
      entryRows,
      inputId,
      newMode,
      fieldConfiguration,
      applicationType,
      paymentType,
      credit
    } = this.props;

    const isCarryoverCredit = credit.fields.payment_type.value === 'Carryover Credit';

    return (
      <div className="parkchirp--credit-panel-entry-table">
        <header className="parkchirp--credit-panel-entry-table--header">
          <div className="parkchirp--credit-panel-entry-table--row">
            {featureFlags.REVERSE_APPLICATIONDATE &&
              <>
                <div className="parkchirp--credit-panel-entry-table--trans-date-column parkchirp--credit-panel-entry-table--cell">
                  <span className="parkchirp--credit-panel-entry-table--column-heading">Trans. Date</span>
                </div>
                {!isCarryoverCredit &&
                  <div className="parkchirp--credit-panel-entry-table--app-date-column parkchirp--credit-panel-entry-table--cell">
                    <span className="parkchirp--credit-panel-entry-table--column-heading">App. Date</span>
                  </div>
                }
              </>
            }
            {!featureFlags.REVERSE_APPLICATIONDATE &&
              <div className="parkchirp--credit-panel-entry-table--date-column parkchirp--credit-panel-entry-table--cell">
                <span className="parkchirp--credit-panel-entry-table--column-heading">Date</span>
              </div>
            }
            <div className="parkchirp--credit-panel-entry-table--type-column parkchirp--credit-panel-entry-table--cell">
              <span className="parkchirp--credit-panel-entry-table--column-heading">Type</span>
            </div>
            {featureFlags.CREDIT_UPDATES &&
              <div className="parkchirp--credit-panel-entry-table--invoice-column parkchirp--credit-panel-entry-table--cell">
                <span className="parkchirp--credit-panel-entry-table--column-heading">Invoice ID</span>
              </div>
            }
            <div className="parkchirp--credit-panel-entry-table--net-amount-column parkchirp--credit-panel-entry-table--cell credit-net-amount">
              <span className="parkchirp--credit-panel-entry-table--column-heading">Net Amount</span>
            </div>
            {featureFlags.OVERPAYMENT_PT2_C &&
              <>
                <div className="parkchirp--credit-panel-entry-table--tax-amount-column parkchirp--credit-panel-entry-table--cell">
                  <span className="parkchirp--credit-panel-entry-table--column-heading">Tax 1</span>
                </div>
                <div className="parkchirp--credit-panel-entry-table--tax-amount-column parkchirp--credit-panel-entry-table--cell">
                  <span className="parkchirp--credit-panel-entry-table--column-heading">Tax 2</span>
                </div>
                <div className="parkchirp--credit-panel-entry-table--tax-amount-column parkchirp--credit-panel-entry-table--cell">
                  <span className="parkchirp--credit-panel-entry-table--column-heading">Tax 3</span>
                </div>
                <div className="parkchirp--credit-panel-entry-table--tax-amount-column parkchirp--credit-panel-entry-table--cell">
                  <span className="parkchirp--credit-panel-entry-table--column-heading">Tax 4</span>
                </div>
                <div className="parkchirp--credit-panel-entry-table--gross-amount-column parkchirp--credit-panel-entry-table--cell">
                  <span className="parkchirp--credit-panel-entry-table--column-heading">Gross Amount</span>
                </div>
              </>
            }
          </div>
        </header>
        <div className="parkchirp--credit-panel-entry-table--body">
          {entryRows.map(entryRow =>
            <CreditEntryTableRow key={entryRow.ident} inputId={`${inputId}--${entryRow.ident}`}
              entry={entryRow.data}
              newMode={newMode}
              credit={credit}
              onChange={this._onCreditEntryChange(entryRow.ident)}
              fieldConfiguration={fieldConfiguration}
              applicationType={applicationType}
              paymentType={paymentType}
              isCarryoverCredit={isCarryoverCredit}
            />
          )}
        </div>
      </div>
    )
  }
}

export default CreditEntryTable;
